interface StateType {
    tab1: string;
    tab2: string;
    tab1Background: string;
    tab2Background: string;
    loopJson: string;
    awardBackground: string;
    award1: string;
    award2: string;
    award3: string;
    award1_g: string;
    award2_g: string;
    award3_g: string;
}
type stateKey = keyof StateType;

interface PayloadType {
    key: stateKey;
    value: string;
}

export default {
    state: {
        tab1: '',
        tab2: '',
        tab1Background: '',
        tab2Background: '',
        loopJson: '',
        awardBackground: '',
        award1: '',
        award2: '',
        award3: '',
        award1_g: '',
        award2_g: '',
        award3_g: ''
    },
    mutations: {
        setBackgrondValue(state: StateType, playLoad: PayloadType) {
            const { key, value } = playLoad;
            if (state[key]) return;
            state[key] = value;
        }
    },

    namespaced: true
};
